<template>
  <div class="ion-item-wrapper ion-item-wrapper-v7 ion-item-wrapper-grey border-thin bg-white" :class="props.customClass">
    <ion-item class="default" lines="none" :id="customId">
      <slot></slot>
    </ion-item>
  </div>
</template>
<script setup>
const props = defineProps(['customClass', 'customId']);
</script>